module.exports = __webpack_public_path__ + "img/loader.cca272ed.gif";